import { ReactNode } from 'react';

import { IconLoading } from '../Icons/IconLoading';

interface ButtonProps {
    children: ReactNode;
    type?: 'button' | 'submit';
    variant?: 'primary' | 'secondary' | 'tertiary';
    size?: 'small' | 'medium' | 'large';
    disabled?: boolean;
    onClick?: () => void;
    isProcessing?: boolean;
    inverted?: boolean;
}

const sizeClasses = {
    small: 'py-[5px] px-4 text-sm ',
    medium: 'py-2 px-6 text-base',
    large: 'py-3 px-7 text-lg',
};

export const Button = ({
    children,
    type = 'button',
    variant = 'primary',
    disabled = false,
    onClick,
    isProcessing = false,
    size = 'medium',
    inverted = false,
}: ButtonProps) => {
    let buttonClasses: string;
    switch (variant) {
        case 'primary':
            buttonClasses = `${
                inverted
                    ? 'bg-white focus:bg-green-200 hover:enabled:bg-green-100 text-green-500'
                    : 'text-white bg-green-500 focus:bg-green-600 hover:enabled:bg-green-600'
            } ${
                sizeClasses[size]
            } rounded-xl border-box border-2 border-transparent outline-none disabled:opacity-30 disabled:cursor-not-allowed`;
            break;
        case 'secondary':
            buttonClasses = `${
                inverted
                    ? 'text-white border-green-200 hover:enabled:text-green-200 focus:border-green-400 focus:text-green-400'
                    : 'text-currentColor hover:text-neutral-500 border-green-200 hover:enabled:bg-green-200'
            } ${sizeClasses[size]} border-box rounded-xl border-2 disabled:cursor-not-allowed disabled:opacity-30`;
            break;
        case 'tertiary':
            buttonClasses =
                'text-green-500 hover:enabled:text-green-600 disabled:cursor-not-allowed disabled:opacity-30';
            break;
        default:
            buttonClasses = '';
    }

    return (
        <button
            className={`transition-all duration-150 ease-in-out font-semibold ${buttonClasses}`}
            type={type}
            disabled={disabled}
            onClick={onClick}
        >
            {isProcessing ? (
                <div className="flex items-center">
                    <div className="w-5 fw-svg">
                        <IconLoading />
                    </div>
                    <span className="opacity-0 w-0">Loading</span>
                </div>
            ) : (
                <>{children}</>
            )}
        </button>
    );
};
